// src/pages/admin/adminPageEditor/components/NonEditorTabsPanel.jsx
import React from "react";
import UsersTab from "../../editorTabs/UsersTab";
import GeneralTab from "../../editorTabs/GeneralTab";
import LimitsTab from "../../editorTabs/LimitsTab";
import { pagesApi } from "../../../../api/pagesApi";

export default function NonEditorTabsPanel({
  tab,
  pageId,
  onToast,
  t,
  pageName,
  setPageName,
  pageSlug,
  setPageSlug,
  general,
  setGeneral,
  limits,
  setLimits,
}) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border p-4 sm:p-5">
      {tab === "users" && <UsersTab pageId={pageId} onToast={onToast} t={t} />}

      {tab === "general" && (
        <GeneralTab
          pageName={pageName}
          setPageName={setPageName}
          pageSlug={pageSlug}
          setPageSlug={setPageSlug}
          general={general}
          setGeneral={setGeneral}
          uploadImage={pagesApi.uploadImage}
        />
      )}

      {tab === "limits" && <LimitsTab limits={limits} setLimits={setLimits} />}
    </div>
  );
}